"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheBakeryStory() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223547" id="our-national-footprint" className="relative overflow-hidden bg-gradient-to-b from-background to-muted py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636043/img/subtle_grid_pattern.png)] bg-repeat opacity-[0.05] mix-blend-multiply" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={imageRef} className={`relative lg:col-span-7 transition-all duration-1000 ease-out ${isImageVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl shadow-2xl shadow-primary/20 md:aspect-[16/9] lg:aspect-[4/5] lg:-rotate-2">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636043/img/new_image_without_text.png" alt="National sanitation network map showing certified service hubs across the USA" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              {}
              <div className="pointer-events-none absolute inset-4 rounded-xl border border-primary/10" />
            </div>

            {}
            <div className="absolute -bottom-12 -left-12 -z-10 h-72 w-72 rounded-[40%_60%_70%_30%/40%_50%_60%_50%] bg-primary/10 blur-3xl" />
          </div>

          {}
          <div ref={textRef} className={`relative z-20 lg:col-span-5 lg:-ml-16 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
            <div className="rounded-2xl border border-border/50 bg-background/95 p-8 shadow-xl shadow-foreground/5 backdrop-blur-md md:p-12">
              <h2 className="mb-8 font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
                Our National Footprint
              </h2>

              <div className="space-y-6 font-default text-lg leading-relaxed text-muted-foreground">
                <p>
                  <span className="float-left mr-4 mt-1 font-default text-7xl font-bold leading-none text-primary md:text-8xl">
                    P
                  </span>
                  ottyForSale.com is the premier national platform for enterprise‑grade
                  portable sanitation. With a coast‑to‑coast network of certified
                  operators, we provide consistent, high‑tier service across all
                  50 states for major infrastructure projects and large‑scale events.
                </p>
                <p>
                  Our commitment to enterprise reliability means you get standardized
                  quality, transparent pricing, and 24/7 logistical support. Whether
                  you are managing a stadium build in Seattle or a music festival
                  in Miami, our national footprint ensures that your sanitation
                  needs are met with precision and professionalism.
                </p>
              </div>

              <div className="mt-10">
                <Button asChild variant="outline" size="lg" className="group rounded-full border-primary text-primary transition-all hover:bg-primary hover:text-primary-foreground">
                  <Link to="#">
                    Read Our Mission
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}